export enum TrafficLightColor {
    GREEN = 'GREEN',
    YELLOW = 'YELLOW',
    RED = 'RED'
}

const TRAFFIC_LIGHT_COLOR_PREFIX = 'ENUM.TRAFFIC_LIGHT_COLOR.';

export function trafficLightColorTranslationKey(color: TrafficLightColor | string | undefined): string {
    return TRAFFIC_LIGHT_COLOR_PREFIX + color;
}

export const trafficLightColorTranslationKeys = Object.values(TrafficLightColor).reduce((translationKeys, color) => {
    translationKeys[color] = trafficLightColorTranslationKey(color);
    return translationKeys;
}, {} as Record<TrafficLightColor, string>);
